/* RovoSearchLoadingState.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2YLqiKIZbP%7Bmargin-inline%3Aauto%7D%0A._2Y7lL4NHnM%7Bpadding-inline%3Avar(--ds-space-300%2C24px)%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._1EqgXlbQX2%7Bmax-width%3A914px%7D%0A._4kiQYADQNZ%7Bmin-height%3A138px%7D");




import React from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
import { FullPageError } from '@townsquare/error-state/ui/index';
import { RovoSearchHeader } from './RovoSearchHeader';
import { RovoSearchInputSkeleton } from './RovoSearchInputSkeleton';
const styles = {
  searchWrapper: "_2YLqiKIZbP _2Y7lL4NHnM _39xV02N91d _1EqgXlbQX2 _4kiQYADQNZ"
};
export const RovoSearchLoadingState = ({
  error
}: {
  error?: unknown;
}): React.JSX.Element => {
  if (error) {
    return <FullPageError testId="rovo-error-screen" />;
  }
  return <>
			<RovoSearchHeader />
			<Box xcss={styles.searchWrapper}>
				<RovoSearchInputSkeleton />
			</Box>
		</>;
};